import FancyHeading from '@/components/FancyHeading';
import { MEDIA_URL } from '@/constants/env';
import { fadeIn, fadeInUp } from '@/constants/motions';
import { useFilterClients } from '@/hooks/useFilterClients';
import Button from '@/ui/Button';
import Image from '@/ui/Image';
import { AnimatePresence, motion } from 'framer-motion';

export default function OurClientsBlock({ clients: clientsAll, companies }) {
  const { company, clients, filterByCompany } = useFilterClients(clientsAll || []);
  return (
    <motion.section
      className="my-16 px-4"
      initial="hidden"
      transition={fadeInUp.transition}
      variants={fadeInUp}
      whileInView="visible"
    >
      <div className="container-screen">
        <FancyHeading>Our Clients</FancyHeading>
        <motion.div
          className="mt-8 flex flex-col justify-center gap-2 md:flex-row"
          initial="hidden"
          transition={fadeInUp.transition}
          variants={fadeInUp}
          viewport={fadeInUp.viewport}
          whileInView="visible"
        >
          {[{ id: 'all', attributes: { name: 'All' } }, ...(companies || [])].map(
            ({ id, attributes: { name } }) => (
              <Button
                key={id}
                active={id === company}
                color="outline"
                onClick={() => filterByCompany(id)}
              >
                {name}
              </Button>
            )
          )}
        </motion.div>
        <motion.div
          layout
          className="mt-8 grid grid-cols-2 gap-2 lg:grid-cols-3 xl:grid-cols-4"
          initial="hidden"
          transition={{
            ...fadeInUp.transition,
            delay: 0.4,
          }}
          variants={fadeInUp}
          viewport={fadeInUp.viewport}
          whileInView="visible"
        >
          <AnimatePresence>
            {(clients || []).map(({ id, attributes }, i) => (
              <motion.div
                key={id}
                layout
                animate="visible"
                className="flex items-center justify-center rounded-xl bg-primary-500/10 p-4 md:p-10"
                exit="hidden"
                variants={fadeIn}
              >
                {attributes?.image?.data?.attributes?.url ? (
                  <Image
                    alt="Client"
                    className="h-24 w-full object-contain"
                    src={MEDIA_URL.concat(attributes.image.data.attributes.url)}
                  />
                ) : null}
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </motion.section>
  );
}
